import { createFileRoute, redirect } from '@tanstack/react-router';
import { inviteAutoAcceptIntent } from '@/features/invites/utils/autoAcceptIntent';
import { getPendingInvites } from '@/features/settings/user-management/api/invitesApi';

export const Route = createFileRoute('/(app)/')({
  loader: async ({ context }) => {
    if (inviteAutoAcceptIntent.peek()) {
      throw redirect({ to: '/invites/auto-accept' });
    }

    const { organizationName, authError } = context;
    // Redirecting to `/` here would re-run this same loader with the same missing token and loop
    // forever; surface the error page instead.
    if (authError) {
      throw new Error('auth_unavailable');
    }
    if (!organizationName) {
      throw redirect({ to: '/' });
    }

    let hasPendingInvites = false;
    try {
      const { invites } = await getPendingInvites();
      hasPendingInvites = invites.length > 0;
    } catch {
      // Invite lookup failure shouldn't block the org redirect below
    }

    if (hasPendingInvites) {
      throw redirect({ to: '/invites' });
    }

    throw redirect({
      to: '/org/$org',
      params: { org: organizationName },
    });
  },
});
